import React from "react";

import {ManualPopover} from "@pg-design/floating-module";
import {CloseIcon} from "@pg-design/icons-module";
import {Message} from "@pg-design/message-module";

import {NavigationUserIcon} from "./NavigationUserIcon";

import * as styles from "./UserIconPopover.module.css";

interface IProps {
    isPopoverActive: boolean;
    onPopoverClose: () => void;
}

export const UserIconPopover = (props: IProps) => {
    const onCloseIconClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        props.onPopoverClose();
    };

    const onOpenChange = (isOpen: boolean) => {
        if (!isOpen) {
            props.onPopoverClose();
        }
    };

    return (
        <ManualPopover
            isOpen={props.isPopoverActive}
            handleSetIsOpen={onOpenChange}
            placement="bottom"
            type="success"
            className={styles.popoverWrapperStyle}
            popover={
                <Message type="success">
                    <div className={styles.popoverContentWrapperStyle}>
                        Załóż konto i korzystaj z dodatkowego wsparcia w poszukiwaniu mieszkania
                        <CloseIcon size="1.6" className={styles.closeIconStyle} onClick={onCloseIconClick} />
                    </div>
                </Message>
            }
        >
            {({refs, getReferenceProps}) => (
                <div ref={refs.setReference} {...getReferenceProps()}>
                    <NavigationUserIcon />
                </div>
            )}
        </ManualPopover>
    );
};
import React from "react";

import {ManualPopover} from "@pg-design/floating-module";
import {CloseIcon} from "@pg-design/icons-module";
import {Message} from "@pg-design/message-module";

import {NavigationUserIcon} from "./NavigationUserIcon";

import * as styles from "./UserIconPopover.module.css";

interface IProps {
    isPopoverActive: boolean;
    onPopoverClose: () => void;
}

export const UserIconPopover = (props: IProps) => {
    const onCloseIconClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        props.onPopoverClose();
    };

    const onOpenChange = (isOpen: boolean) => {
        if (!isOpen) {
            props.onPopoverClose();
        }
    };

    return (
        <ManualPopover
            isOpen={props.isPopoverActive}
            handleSetIsOpen={onOpenChange}
            placement="bottom"
            type="success"
            className={styles.popoverWrapperStyle}
            popover={
                <Message type="success">
                    <div className={styles.popoverContentWrapperStyle}>
                        Załóż konto i korzystaj z dodatkowego wsparcia w poszukiwaniu mieszkania
                        <CloseIcon size="1.6" className={styles.closeIconStyle} onClick={onCloseIconClick} />
                    </div>
                </Message>
            }
        >
            {({refs, getReferenceProps}) => (
                <div ref={refs.setReference} {...getReferenceProps()}>
                    <NavigationUserIcon />
                </div>
            )}
        </ManualPopover>
    );
};
